<template>
  <div class="must-read" :class="{ 'not-subscribe': notSubscribe }">
    <div class="must-read__number">
      {{ number }}
    </div>
    <div class="must-read__title">
      <nuxt-link :to="link" v-html="text" />
    </div>
    <Tooltip v-if="notSubscribe" />
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "MustRead",
  components: {
    Tooltip: () => import("../elements/Tooltip"),
  },
  props: {
    number: {
      type: Number,
      default: null,
    },
    link: {
      type: String,
      default: "/",
    },
    text: {
      type: String,
      default: null,
    },
    productAccess: {
      type: [Array, Number],
      default: null,
    },
  },
  data: () => ({
    notSubscribe: false,
  }),
  computed: {
    ...mapState("Profile", ["userAccess"]),
  },
  mounted() {
    if (!this.productAccess || !this.productAccess.length) {
      this.notSubscribe = false;
    } else {
      for (let i = 0; i < this.productAccess.length; i++) {
        if (this.userAccess.includes(this.productAccess[i])) {
          this.notSubscribe = false;
          if (this.productAccess[i]) break;
        } else {
          this.notSubscribe = true;
        }
      }
    }
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";

.must-read {
  display: flex;
  position: relative;
  &__number {
    // line-height: 4.2rem;
    font-size: 4.2rem;
    font-weight: 300;
    color: $counterColor;
    margin-right: 3rem;
    width: 2rem;
  }
  &__title {
    width: calc(100% - 2rem);
    a {
      font-size: 1.6rem;
      line-height: 2rem;
      font-weight: 700;
      color: $text_gray;
      text-decoration: none;
    }
  }
}
</style>
